import { memo } from 'react';
import { TimeUtils } from 'src/utils';
import { formatTime } from 'src/utils/date';
import { Element } from 'src/components';
import styles from './styles.module.scss';
interface IProps {
    date: number;
    displayTimeIn?: number;
}

export function ContentTime({ date, displayTimeIn = 0 }: IProps) {
    if (!date) {
        return null;
    }

    const currentTime = TimeUtils.currentSecords();

    if (displayTimeIn > 0 && currentTime - date > displayTimeIn) {
        return null;
    }
   
    return (
        <Element renderAs="span" className={styles['content-time']} suppressHydrationWarning>
            {formatTime(date)}
        </Element>
    );
}

export default memo(ContentTime);
